<template>
  <div id="registrationStatis">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'registrationStatis'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/statistical/exhibition/RegistrationStatis.vue